module.exports = __webpack_public_path__ + "static/media/engine.0680df1f.svg";